import React from 'react';
import { Layout, Dropdown, Menu, Button, Icon, message} from 'antd';
import common from "../assets/common.js";
import head from '../images/head.svg';
const { Header } = Layout;


class Head extends React.Component {
  state = {
    userAdmin : {},
  }
  logout = () => {
    var postData = {};
    postData["_url"] = "api/admin/logout"
    common.request(postData, this, function(obj, data){
      // message.info('退出成功');
      window.info = {};
      obj.props.history.push('login');
    })
  }
  changeToSuper = () => {
    var postData = {};
    postData["_url"] = "admin/superAdmin/AdminToSuper";
    common.request(postData, this, function(obj, data){
      window.location.href = "index.html#/school";
      message.info("切换成功");
    });
  }
  // 回到超管
  returnTo = () => {
    var postData = {};
    postData["_url"] = "api/admin/goback";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data){
      window.location.href = window.location.origin + window.location.pathname + "#/school";
      window.location.reload();
      message.info("切换成功");
    });
  }
  render() {
    const collapsed = this.props.collapsed;
    const superAdminButton = this.props.superAdminButton;
    const org = this.props.org;
    const menu = (
      <Menu>
        <Menu.Item>
          <a onClick={ this.logout.bind(this) }>退出</a>
        </Menu.Item>
      </Menu>
    )
    return (
      <Header id="headDiv">
        <div className="headLeft pull-left">
          <Icon id="menuSwitch" className="cursor-pointer" type={ collapsed ? 'menu-unfold' : 'menu-fold'}  onClick={ this.props.changeCollapsed.bind(this, !collapsed) }/>
        </div>
        <div className="headRight pull-right">
          { superAdminButton && <Button className="pull-left mr-8" onClick={ this.returnTo }  title="回到超管"><Icon type="arrow-left" />回到超管</Button> }
          <div className="pull-left mr-8">
            <div id="headImg">
              <img src={ org.orgLogo?org.orgLogo:head } alt="" />
            </div>
          </div>
          <div className="adminName">
            <Dropdown overlay={menu} trigger={[ "click" ]} getPopupContainer={() => document.getElementsByClassName('adminName')[0] }>
              <span className="cursor-pointer">
                <span>{ org.orgName }</span>
                <Icon type="down" /></span>
            </Dropdown>
        </div>
        </div>
      </Header>
    )
  }
}
export default Head;



// WEBPACK FOOTER //
// ./src/index/head.js